import template from './edit-notification-subscription.html';

const DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

class EditNotificationSubscriptionVM
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.editing = ko.observable(false);
		this.notification_subscription_id = ko.observable(null);
		this.notification_type_name = ko.observable('');

		this.channels = ko.observableArray([]);
		this.selected_channel_id = ko.observable(null);
		this.is_ignore = ko.observable(false);
		this.delay_tod_start = ko.observable('00:00:00');
		this.delay_tod_end = ko.observable('24:00:00');
		this.context_match_text = ko.observable('{}');

		this.days = ko.observableArray(
			DAY_NAMES.map((name, idx) => ({
				name: name,
				idx: idx,
				checked: ko.observable(true)
			}))
		);

		this.context_fields = ko.observableArray([]);
	}

	getDowString ()
	{
		return this.days().map(d => d.checked() ? '1' : '0').join('');
	}

	setDowString (dow)
	{
		const days = this.days();
		for (let i = 0; i < 7; i++)
			days[i].checked(dow && dow.length > i ? dow[i] === '1' : true);
	}

	async btnSave_click ()
	{
		if (!this.selected_channel_id())
		{
			Grape.alerts.alert({ type: 'warning', title: 'Validation', message: 'Please select a channel' });
			return;
		}

		let context_match = {};
		try
		{
			const text = this.context_match_text();
			if (text && text.trim().length > 0)
				context_match = JSON.parse(text);
		}
		catch (e)
		{
			Grape.alerts.alert({ type: 'warning', title: 'Validation', message: 'Context match must be valid JSON' });
			return;
		}

		const input = {
			notification_type_id: this.dialog.bindings.notification_type
				? this.dialog.bindings.notification_type.notification_type_id
				: this.dialog.bindings.subscription.notification_type_id,
			notification_channel_id: parseInt(this.selected_channel_id()),
			is_ignore: this.is_ignore(),
			delay_dow: this.getDowString(),
			delay_tod_start: this.delay_tod_start(),
			delay_tod_end: this.delay_tod_end(),
			context_match: context_match
		};

		if (this.notification_subscription_id())
			input.notification_subscription_id = this.notification_subscription_id();

		const result = await Grape.fetches.postJSON('/api/notifications/subscription', input);

		if (result.status !== 'OK')
		{
			Grape.alerts.alert({ type: 'error', title: 'Error', message: result.message || 'Failed to save' });
			return;
		}

		this.dialog.close(true);
	}

	btnClose_click ()
	{
		this.dialog.close(null);
	}
}

class EditNotificationSubscriptionDialog
{
	constructor (bindings, element)
	{
		this.bindings = bindings;
		this.element = element;
		this.viewModel = new EditNotificationSubscriptionVM(this);
		this.name = 'EditNotificationSubscriptionDialog';
		this.init();
	}

	async init ()
	{
		this.viewModel.channels(this.bindings.channels || []);

		if (this.bindings.subscription)
		{
			const sub = this.bindings.subscription;
			this.viewModel.editing(true);
			this.viewModel.notification_subscription_id(sub.notification_subscription_id);
			this.viewModel.notification_type_name(
				sub.notification_group + ' / ' + sub.notification_name
			);
			this.viewModel.selected_channel_id(String(sub.notification_channel_id));
			this.viewModel.is_ignore(sub.is_ignore || false);
			this.viewModel.delay_tod_start(sub.delay_tod_start || '00:00:00');
			this.viewModel.delay_tod_end(sub.delay_tod_end || '24:00:00');
			this.viewModel.setDowString(sub.delay_dow);
			this.viewModel.context_match_text(
				sub.context_match ? JSON.stringify(sub.context_match, null, 2) : '{}'
			);

			if (sub.context_fields)
				this.viewModel.context_fields(
					Array.isArray(sub.context_fields) ? sub.context_fields : []
				);
		}
		else if (this.bindings.notification_type)
		{
			const nt = this.bindings.notification_type;
			this.viewModel.editing(false);
			this.viewModel.notification_type_name(
				nt.notification_group + ' / ' + nt.notification_name
			);

			if (nt.context_fields)
				this.viewModel.context_fields(
					Array.isArray(nt.context_fields) ? nt.context_fields : []
				);
		}
	}
}

export default {
	name: 'EditNotificationSubscription',
	dialog_class: EditNotificationSubscriptionDialog,
	template: template,
	provider: 'ps'
}
